export default "__VITE_ASSET__CBlXZ7P___ 584w";